import { useLocation, useRouteMatch } from 'react-router-dom'
import type { Location } from 'history'

type BgState = { background?: Location }
type Params = { folderPathBase64?: string }

/**
 * Returns:
 *  - baseUrl: the base route for media library (without the :folderPathBase64 segment)
 *  - background: the current location (or preserved background) to keep the library mounted under the modal
 */
export function useDetailLinkBase() {
  const location = useLocation<BgState>()
  const match = useRouteMatch<Params>()

  // remove the optional folder segment from the *url* so it matches `${path}/detail/:fileId`
  const baseUrl =
    match.params.folderPathBase64
      ? match.url.replace(`/${match.params.folderPathBase64}`, '')
      : match.url

  const background: Location = (location.state?.background ?? location) as Location
  return { baseUrl, background }
}
